import genericReviewQuestionApi from "../../api/rest/genericReviewQuestionApi";
import skillApi from "../../api/rest/skillApi";
import {ALERT_VARIANT} from "../../const/dataEnum";
import {setAlert} from "../actions/alertModalStateAction";

const updateQuestions = (questions, isGeneralQuestion) => async (dispatch) => {
  let data = null;

  if (isGeneralQuestion) {
    data = await genericReviewQuestionApi.updateBatch(questions)
  } else {
    data = await skillApi.updateBatch(questions)
  }

  let message = 'Something went wrong';
  let toastVariat = ALERT_VARIANT.ERROR;

  if (data) {
    if (data.responseCode === 0) {
      message = 'Successfully updated questions';
      toastVariat = ALERT_VARIANT.SUCCESS;
    } else {
      message = data.message;
    }
  } else {
    message = data.message;
  }

  dispatch(setAlert({
    show: true,
    variant: toastVariat,
    message: message,
  }));
};

const removeNewQuestionFromState = (questionsState, question, isGeneralQuestion) => {
  let newQuestions = [];
  if (isGeneralQuestion) {
    newQuestions = questionsState.filter((ques) => ques.question !== question.question);
  } else {
    newQuestions = questionsState.filter((ques) => ques.name !== question.name);
  }
  return newQuestions
}

export const manageQuestionBusiness = {
  updateQuestions,
  removeNewQuestionFromState
};